export class FireFlyError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, FireFlyError.prototype);
    }
}
